const EVENT = "tradestation";
const EVENTCAT = "Tradestation";
const SITE = "FNO";
const SUCCESS = "Complete";
const ERROR = "Failure";
const { REACT_APP_ENV, REACT_APP_URL_WEBSOCKET } = process.env;
function pushAnalytics(eventAction, eventLabel) {
    try {
        // if (!window.location.href.includes("/tradingviewchart")) {
        if (window.dataLayer && eventAction && eventLabel) {
            window.dataLayer.push({
                event: EVENT,
                eventCategory: EVENTCAT,
                eventAction: eventAction.trim(),
                eventLabel: eventLabel.trim(),
            });
        }
        // }
    }
    catch (err) {
        console.error(eventAction + "Something went wrong in anlytics capturing" + eventLabel);
    }
    return;
}
function pushCleverTabAnalytics(eventAction, eventLabel) {
    if (window.clevertap) {
        window.clevertap.event.push(eventAction, eventLabel);
    }
    return;
}
function captureCleverTabAnalytics(eventAction, eventLabel) {
    try {
        pushCleverTabAnalytics(eventAction, eventLabel);
    }
    catch (err) {
        console.error("Something went wrong in clever analytics capturing - captureCleverTabAnalytics");
    }
    return;
}
function captureSimpleAnalytics(eventAction, eventCategory) {
    try {
        if (eventAction && eventCategory) {
            pushAnalytics(eventAction, eventCategory);
        }
    }
    catch (err) {
        console.error("Something went wrong in anlytics capturing - SimpleAnalytics");
    }
    return;
}
//eventaction Buy or Sell , eventLabel : stock
function captureBuySellAnalytics(isSuccess, BuyorSell, StockName) {
    try {
        if (isSuccess)
            pushAnalytics(`${BuyorSell.charAt(0).toUpperCase() + BuyorSell.slice(1).toLowerCase()} ${SITE} Stock ${SUCCESS}`, StockName);
        else
            pushAnalytics(`${BuyorSell.charAt(0).toUpperCase() + BuyorSell.slice(1).toLowerCase()} ${SITE} Stock ${ERROR}`, StockName);
    }
    catch (err) {
        console.error("Something went wrong in anlytics capturing - BuySellAnalytics");
    }
    return;
}
function captureAddToBasket(isSuccess, StockName) {
    try {
        if (isSuccess) {
            pushAnalytics(`Add to basket - ${SITE}`, StockName);
        }
        else {
            pushAnalytics(`Add to basket - ${SITE} ${ERROR}`, StockName);
        }
    }
    catch (err) {
        console.error("Something went wrong in anlytics capturing - captureAddToBasket");
    }
    return;
}
function captureAddToWatchlistAnalytics(isSuccess, StockName) {
    try {
        if (isSuccess)
            pushAnalytics(`Add to watchlist - ${SITE}`, StockName);
        else
            pushAnalytics(`Add to watchlist - ${SITE} ${ERROR}`, StockName);
    }
    catch (err) {
        console.error("Something went wrong in anlytics capturing - captureAddToWatchlistAnalytics");
    }
    return;
}
function captureErrorDetailedAnalytics(eventAction, error, ...eventLabels) {
    captureDetailedAnalytics(eventAction, ...eventLabels, error.message);
    return;
}
function captureDetailedAnalytics(eventAction, ...eventLabels) {
    try {
        //const eventLabel:string=eventLabels.reduce((result,item)=>result=result+`- ${item} `,'');
        const eventLabel = eventLabels.join(" - ");
        pushAnalytics(eventAction, eventLabel);
    }
    catch (err) {
        console.error("Something went wrong in anlytics capturing - captureDetailedAnalytics");
    }
    return;
}
export { captureSimpleAnalytics, captureDetailedAnalytics, captureErrorDetailedAnalytics, captureBuySellAnalytics, captureAddToBasket, captureAddToWatchlistAnalytics, captureCleverTabAnalytics, };
